import { ThemeColor, ThemeTonalRange, ThemeService } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';

interface Theme {
  dsCorAplicacao: ThemeColor;
  dsCorAccent: ThemeColor;
  dsCorNavegacao: ThemeTonalRange;
  dsCorConteudo: ThemeTonalRange;
  dsCorLogin: ThemeTonalRange;
  dsLogoLogin: string;
  nmInstituicao: string;
}

//@ts-ignore
function setupTheme(): Promise<Theme> {
  return HttpService.get(APPLICATION_ENDPOINTS.CONFIGURATION,{})
    .then(responseGetConfiguration => {
      //eslint-disable-next-line @typescript-eslint/no-unused-vars
      let {
        dsCorAplicacao,
        dsCorAccent,
        dsCorNavegacao,
        dsCorLogin
      } = responseGetConfiguration.body as Theme;

      const { nmInstituicao } = responseGetConfiguration.body as Theme;

      dsCorAplicacao = dsCorAplicacao || ThemeColor.GROUP_BLUE
      dsCorAccent = dsCorAccent || ThemeColor.AQUA
      dsCorNavegacao = dsCorNavegacao || ThemeTonalRange.BRIGHT
      dsCorLogin = dsCorLogin || ThemeTonalRange.BRIGHT

      applicationContext.setTitle(nmInstituicao);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ThemeService.setColors(dsCorAplicacao, dsCorAccent as any);
      ThemeService.setContentTonalRange(dsCorLogin);
      ThemeService.setNavigationTonalRange(dsCorNavegacao);

      return responseGetConfiguration.body as Theme;
    });
}

export {
  setupTheme,
};